module.exports = __webpack_public_path__ + "static/media/mis_datoss_gris.a2bdea0f.svg";